
































import { InputPolicy, MaxBiteFilter } from "@/common/utils";
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import QErrors from "../../common/qErrors.vue";
import postalCodeApi from "@/api/postalCodeApi";

@Component({
  name: "PostalCode",
  components: {
    QErrors,
  },
})
export default class PostalCode extends Vue {
  @Prop()
  errors: any;
  @Prop()
  value: string;
  @Prop()
  errorKey: string;
  @Prop({
    default: 7
  })
  max: number;
  @Prop({ default: "mb__button" })
  classes: string;
  isNotFound:boolean = false;
  isLoading = false;
  postalError: string = "";

  public fullWidthNumConvert(fullWidthNumber) {
    return fullWidthNumber.replace(/[\uFF10-\uFF19]/g, function (m) {
      return String.fromCharCode(m.charCodeAt(0) - 0xFEE0);
    });
  }

  mounted() {
    this.isNotFound = false;
    this.postalError = "";
  }

  public async search() {
    this.isLoading = true;
    this.isNotFound = false;
    this.postalError = "";

    try {
      const code = this.fullWidthNumConvert(this.value);
      const response = await postalCodeApi.getDetail(code);
      const data = response.data;

      if (data.meta && data.meta.status !== 200) {
        this.postalError = data.meta.message;
        return;
      }

      if (data.data && data.data.pref_name) {
        this.$emit("result", {
          pref_name: data.data.pref_name,
          city_name: data.data.city_name,
          address: "",
          prefecture_code: data.data.prefecture_code,
        });
      } else {
        this.isNotFound = true;
      }
    } catch (error: any) {
      if (error.response && error.response.data && error.response.data.meta) {
        this.postalError = error.response.data.meta.message;
      } else {
        console.error(error);
        this.isNotFound = true;
      }
    } finally {
      this.isLoading = false;
    }
  }
  handleChange(event) {
    const updated = this.replaceInput(event.target.value);
    event.target.value = updated;
    this.$emit("input", updated);
  }

  replaceInput (input: string) {
    const checked = InputPolicy.check(input, 'Number');
    return MaxBiteFilter(checked, this.max);
  }
}
